import React, { useState, useEffect } from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Menu from "../../components/menu/Menu";
import Grafico from "../../components/graficos/Grafico";
import { calcPresencas } from "../../services/presencasService";
import { getEvolucaoAtivos } from "../../services/evolucaoAtivosService";

function Dashboard() {
  const history = useHistory();

  const categories1 = [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999];
  const data1 = [30, 40, 35, 50, 49, 60, 70, 91, 125];

  const categories2 = [
    "2024-12-01",
    1992,
    1993,
    1994,
    1995,
    1996,
    1997,
    1998,
    1999,
  ];
  const data2 = [5, 2, 0, 10, 1, 5, 4, 9, 12];

  const [error, setError] = useState("");

  const [infoGraficoEntradas, setinfoGraficoEntradas] = useState({
    options: {
      chart: {
        id: "apexchart-example",
        height: 350,
      },
      xaxis: {
        categories: [],
      },
      /*colors: "#FFCC53",*/
      //colors: "#CC3300",
      colors: ["#FEB019"],
    },
    series: [],
  });

  const [infoGraficoAtivos, setinfoGraficoAtivos] = useState({
    options: {
      chart: {
        id: "apexchart-ativos",
        height: 350,
      },
      stroke: {
        curve: ["smooth", "straight", "smooth"],
        width: [4, 1, 1],
      },
      xaxis: {
        /*categories: [
          "2024 01",
          "2024 02",
          "2024 03",
          "2024 04",
          "2024 05",
          "2024 06",
          "2024 07",
          "2024 08",
          "2024 09",
          "2024 10",
          "2024 11",
          "2024 12",
        ],*/
        categories: [],
      },
      /*colors: "#FFCC53",*/
      //colors: ["#FFCC53", "#CC3300"],
      colors: ["#008FFB", "#FEB019", "#CC3300"],

      dataLabels: {
        enabled: true,
        enabledOnSeries: [1],
      },
      yaxis: [
        {
          title: {
            text: "Ativos",
          },
        },
        {
          opposite: true,
          title: {
            text: "Inscrições",
          },
        },
        {
          opposite: true,
          title: {
            text: "Cancelamentos",
          },
        },
      ],
      tooltip: {
        fixed: {
          enabled: false,
          position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
          offsetY: 30,
          offsetX: 60,
        },
      },
    },
    series: [
      {
        name: "Ativos",
        type: "line",
        data: [],
      },
      {
        name: "Inscrições",
        type: "column",
        data: [],
      },
      {
        name: "Cancelamentos",
        type: "line",
        data: [],
      },
    ],
  });

  const [infoGraficoReceitas, setinfoGraficoReceitas] = useState({
    options: {
      chart: {
        height: 350,
        type: "bar",
      },
      colors: ["#FEB019"],
      plotOptions: {
        bar: {
          borderRadius: 20,
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val + "%";
        },
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },

      xaxis: {
        categories: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez",
        ],
        position: "top",
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        crosshairs: {
          fill: {
            type: "gradient",
            gradient: {
              colorFrom: "#D8E3F0",
              colorTo: "#BED1E6",
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            },
          },
        },
        tooltip: {
          enabled: true,
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
          formatter: function (val) {
            return val + "%";
          },
        },
      },
      title: {
        text: "Monthly Inflation in Argentina, 2002",
        floating: true,
        offsetY: 330,
        align: "center",
        style: {
          color: "#444",
        },
      },
    },
    series: [
      {
        name: "Receitas",
        data: [2.3, 3.1, 4.0, 10.1, 4.0, 3.6, 3.2, 2.3, 1.4, 0.8, 0.5, 0.2],
      },
    ],
  });

  const [infoGraficoFinanceiro, setinfoGraficoFinanceiro] = useState({
    series: [
      {
        name: "Income",
        type: "column",
        data: [1.4, 2, 2.5, 1.5, 2.5, 2.8, 3.8, 4.6],
      },
      {
        name: "Cashflow",
        type: "column",
        data: [1.1, 3, 3.1, 4, 4.1, 4.9, 6.5, 8.5],
      },
      {
        name: "Revenue",
        type: "line",
        data: [20, 29, 37, 36, 44, 45, 50, 58],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
        stacked: false,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: [1, 1, 4],
      },
      title: {
        text: "XYZ - Stock Analysis (2009 - 2016)",
        align: "left",
        offsetX: 110,
      },
      xaxis: {
        categories: [2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016],
      },
      yaxis: [
        {
          seriesName: "Income",
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: "#008FFB",
          },
          labels: {
            style: {
              colors: "#008FFB",
            },
          },
          title: {
            text: "Income (thousand crores)",
            style: {
              color: "#008FFB",
            },
          },
          tooltip: {
            enabled: true,
          },
        },
        {
          seriesName: "Cashflow",
          opposite: true,
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: "#00E396",
          },
          labels: {
            style: {
              colors: "#00E396",
            },
          },
          title: {
            text: "Operating Cashflow (thousand crores)",
            style: {
              color: "#00E396",
            },
          },
        },
        {
          seriesName: "Revenue",
          opposite: true,
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: "#FEB019",
          },
          labels: {
            style: {
              colors: "#FEB019",
            },
          },
          title: {
            text: "Revenue (thousand crores)",
            style: {
              color: "#FEB019",
            },
          },
        },
      ],
      tooltip: {
        fixed: {
          enabled: true,
          position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
          offsetY: 30,
          offsetX: 60,
        },
      },
      legend: {
        horizontalAlign: "left",
        offsetX: 40,
      },
    },
  });

  useEffect(() => {
    const token = localStorage.getItem("token");

    getEvolucaoAtivos(token)
      .then((response) => {
        console.log(response);

        const responseR = response.reverse();
        console.log("REVERSE: ", responseR);

        const meses = responseR.map((o) => o.coluna1);
        console.log("meses", meses);

        const emDia = responseR.map((o) =>
          o.coluna4 === "" ? 0 : parseInt(o.coluna4)
        );

        const inscricoes = responseR.map((o) =>
          o.coluna9 === "" ? 0 : parseInt(o.coluna9)
        );
        console.log("inscricoes", inscricoes);

        const cancelamentos = responseR.map((o) =>
          o.coluna7 === "" ? 0 : parseInt(o.coluna7)
        );
        console.log("cancelamentos", cancelamentos);

        setinfoGraficoAtivos({
          options: {
            ...infoGraficoAtivos.options,
            xaxis: {
              ...infoGraficoAtivos.options.xaxis,
              categories: meses,
            },
          },

          /*series: [
            {
              name: infoGraficoAtivos.series(0).name,
              type: infoGraficoAtivos.series(0).type,
              data: inscricoes,
            },
            {
              name: infoGraficoAtivos.series(1).name,
              type: infoGraficoAtivos.series(1).type,
              data: infoGraficoAtivos.series(1).data,
            },
          ],*/
          /*[
            {
              name: "Ativos",
              //data: [63, 69, 52, 67, 67, 67, 101, 76, 137, 109, 74, 36],
              data: emDia,
              type: "line",
            },
            {
              name: "Inscrições",
              //data: [63, 69, 52, 67, 67, 67, 101, 76, 137, 109, 74, 36],
              data: inscricoes,
              type: "column",
            },
            {
              name: "Cancelamentos",
              //data: [69, 86, 82, 83, 79, 77, 123, 113, 120, 118, 101, 0],
              data: cancelamentos,
              type: "line",
            },
          ],*/
          series: infoGraficoAtivos.series.map((serie) => {
            if (serie.name === "Ativos") {
              return { ...serie, data: emDia };
            } else {
              if (serie.name === "Inscrições") {
                return { ...serie, data: inscricoes };
              } else {
                if (serie.name === "Cancelamentos") {
                  return { ...serie, data: cancelamentos };
                }
              }
            }
          }),
          tooltip: { ...infoGraficoAtivos.tooltip },
        });
      })
      .catch((err) => {
        if (err.response && err.response.status === 401)
          return history.push("/");

        setError(err.response ? err.response.data : err.message);
      });

    //let data2 = new Date();
    //let data1 = data2.setDate(data2.getDate() - 7);

    //const data2 = moment();
    const periodo = moment.duration(7, "days");
    const data1 = moment().subtract(periodo);
    /*
    data1 =
      data1.getFullYear() +
      "-" +
      (data1.getMonth() + 1) +
      "-" +
      data1.getDate();

    data2 =
      data2.getFullYear() +
      "-" +
      (data2.getMonth() + 1) +
      "-" +
      data2.getDate();
      */
    calcPresencas(
      token,
      data1.format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    )
      .then((response) => {
        /*setPresencasData(response.data);
        setPresencasValor(response.valor);*/

        let datas = [];
        response.count.forEach((i, index) => datas.push(i.data));
        //console.log("arr_datas", datas);

        let entradas = [];
        response.count.forEach((i) => entradas.push(i.count));
        //console.log("arr_entradas", entradas);

        setinfoGraficoEntradas({
          ...infoGraficoEntradas,
          options: {
            ...infoGraficoEntradas.options,
            xaxis: {
              ...infoGraficoEntradas.options.xaxis,
              /*categories: [
                ...infoGraficoEntradas.options.xaxis.categories,
                datas,
              ],*/
              categories: datas,
            },
          },
          series: [
            /*...infoGraficoEntradas.series,
            {
              name: "entradas",
              data: [...infoGraficoEntradas.series[0].data, entradas],
            },*/
            {
              name: "entradas",
              data: entradas,
            },
          ],
        });

        /*console.log("infoGraficoEntradas: ", infoGraficoEntradas);
        console.log("API call calcPresencas RESPONSE:y ", response);*/
      })
      .catch((err) => {
        if (err.response && err.response.status === 401)
          return history.push("/");

        setError(err.response ? err.response.data : err.message);
      });
  }, []);

  return (
    <>
      <Menu />
      <main className="content">
        <h1>Dashboard</h1>
        <div className="row">
          <div className="col-md-6">
            <div className="card card-body border-0 shadow mb-4">
              <h4>Inscrições v. Cancelamentos</h4>
              {/*infoGraficoEntradas.options.xaxis.categories*/}
              {/*infoGraficoEntradas.series.length > 0 && infoGraficoEntradas.series[0].data*/}
              {infoGraficoAtivos.series.length > 0 && (
                <Grafico
                  type="line"
                  options={infoGraficoAtivos.options}
                  series={infoGraficoAtivos.series}
                  serie="Inscrições"
                />
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="card card-body border-0 shadow mb-4">
              <h4>Entradas nos últimos 7 dias</h4>
              {infoGraficoEntradas.series.length > 0 && (
                <Grafico
                  type="bar"
                  options={infoGraficoEntradas.options}
                  series={infoGraficoEntradas.series}
                  serie="Entradas"
                />
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="card card-body border-0 shadow mb-4">
              <h4>Receitas</h4>
              {
                <Grafico
                  type="bar"
                  options={infoGraficoReceitas.options}
                  series={infoGraficoReceitas.series}
                  serie="Receitas"
                />
              }
            </div>
          </div>
          <div className="col-md-6">
            <div className="card card-body border-0 shadow mb-4">
              <h4>Financeiro</h4>
              {
                <Grafico
                  type="line"
                  options={infoGraficoFinanceiro.options}
                  series={infoGraficoFinanceiro.series}
                  serie="Financeiro"
                />
              }
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default Dashboard;
